import React from "react";
import {getDescription} from "./CvParser";
import IdReference from "./IdReference";

const CvCategory = ({data, depth, cvs}) => {

    const {idReference = [], category = []} = data

    const boxstyle = {
        border: '1px solid #333333',
        margin: '10px',
    }

    const contentstyle = {
        margin: '10px',
    }

    const headerstyle = {
        fontSize: `${18 - depth * 2}px`,
        margin: `${7}px`,
    }

    return (
        <div style={boxstyle}>
            <div style={headerstyle}>
                [{depth}] {getDescription(data)}
            </div>
            <div style={contentstyle}>

                {idReference.map(it => {
                    return <IdReference key={it?.id} data={it} cvs={cvs} />
                })}

            </div>

            {category.map((it, i) => {
                return <CvCategory key={i} data={it} cvs={cvs} depth={depth + 1}/>
            })}
        </div>
    )
}

export default CvCategory